import { createSlice } from '@reduxjs/toolkit'

const errorSlice = createSlice({
    name: 'errors',
    initialState: {
        error: {}
    },
    reducers: {
        geterrors: (state, action) => {
            // Never let this become undefined/null — every consumer does
            // Object.keys(error) without a guard, and a bad payload here
            // (e.g. a network error with no response body) would crash
            // every page that reads it. See src/utils/getErrorData.js.
            state.error = action.payload && typeof action.payload === 'object' ? action.payload : {}
        },
        setError: (state, action) => {
            state.error = action.payload && typeof action.payload === 'object' ? action.payload : {}
        },
        clearerror: (state, action) => {
            return {
                error: {}
            }
        },
    },
})

export const { geterrors, clearerror, setError } = errorSlice.actions


export default errorSlice.reducer